import {uuid} from 'uuidv4';
import Dispatchable from "utils/Dispatchable.js";
import {
    setSequencers,
    setSequencerTracks
} from 'actions/index.js';

export default superclass => class extends superclass {
    sequencers = [];

    createSequencer() {
        let sequencer = new Sequencer(this);
        this.sequencers = [...this.sequencers, sequencer];
        this.updateRedux();
        return sequencer;
    }

    removeSequencer(sequencer) {
        this.sequencers = this.sequencers.filter(
            s => s !== sequencer);

        this.updateRedux();
    }

    deleteTrackFromSequencers(track) {
        this.sequencers.filter(
            x => x.tracks.includes(track))
            .forEach(
                x => x.removeTrack(track));
    }

    getSequencersJson() {
        return this.sequencers.map(p => p.getJson());
    }

    loadSequencersJson(json) {
        if (!json) {
            return;
        }
        for (let _sequencer of json) {
            let sequencer = this.createSequencer();
            sequencer.fromJson(_sequencer);
        }
    }

    updateRedux() {
        this.dispatch(
            setSequencers(
                this.id, this.sequencers));
    }
}

class Sequencer extends Dispatchable(class {}) {
    constructor(subSequence) {
        super();
        this.subSequence = subSequence;
        this.sequencerEngine = subSequence.sequencerEngine;
        this.id = uuid();
        this.tracks = [];
    }

    dispose() {
        this.tracks.forEach(s => s.sequencer = undefined);
        this.subSequence.removeSequencer(this);
    }

    fromJson(json) {
        this.id = json.id;
        this.x = json.x;
        this.y = json.y;

        if (json.width && json.height) {
            this.width = json.width;
            this.height = json.height;
        }
        
        for (let _track of json.tracks) {
            // look for track
            let track = this.subSequence.tracks.find(x => x.id === _track);
            if (track) {
                this.addTrack(track);
            }
        }
    }

    getJson() {
        return {
            id: this.id,
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            tracks: this.tracks.map(x => x.id)
        };
    }

    removeTrack(track) {
        this.tracks = this.tracks.filter(x => x !== track);
        track.sequencer = undefined;
        this.updateRedux();
    }

    addTrack(track, slotNumber=this.tracks.length) {
        if (this.tracks.includes(track)) {
            return;
        }
        track.sequencer = this;
        this.tracks[slotNumber] = track;
        this.updateRedux();
    }

    updateRedux() {
        this.tracks = [... this.tracks];
        this.dispatch(
            setSequencerTracks(
                this.id, this.tracks));
    }
}
